module.exports = __webpack_public_path__ + "static/media/shapeCircular.0e7b3865.png";